import http from '@/api/http'
import { IEmailMessage } from '@/utils/types'

export const getCannedEmails = () => http.get('/email/cannedemails')

export const formatEmailMessage = (params: any) => http.post('/email/formatEmailMessage', params)

export const sendEmail = (email: IEmailMessage) => http.post('/email/sendemail', email)
